import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommunityListComponent } from './community-list.component';

@NgModule({
  imports: [CommonModule, CommunityListComponent],
  exports: [CommunityListComponent],
})
export class CommunityListComponentModule {}
